module.exports = __webpack_public_path__ + "598579484b4cb2ee88428dd15e5c3e95.png";